import {App} from "@capacitor/app";
import {GoogleAuth} from "@codetrix-studio/capacitor-google-auth";
import {closestCorners, DndContext, DragOverlay, MouseSensor, rectIntersection, TouchSensor, useSensor, useSensors} from "@dnd-kit/core";
import chroma from "chroma-js";
import {getApp} from "firebase/app";
import {getAuth, GoogleAuthProvider, signInWithCredential} from "firebase/auth";
import React, {useEffect} from "react";
import * as ReactColor from "react-color";
import ReactGA from "react-ga";
import {AddressBarWrapper, ErrorBoundary, InfoButton, LoadURL, Observer, RunInAction} from "web-vcore";
import {Clone, Timer} from "js-vextensions";
import {AsyncTrunk} from "mobx-sync";
import {makeObservable, observable} from "mobx";
import {ColorPickerBox, Column} from "react-vcomponents";
import {BaseComponent, BaseComponentPlus} from "react-vextensions";
import {VMenuLayer} from "react-vmenu";
import {MessageBoxLayer} from "react-vmessagebox";
import "../../Source/Utils/Styles/Main.scss"; // keep absolute-ish, since scss file not copied to Source_JS folder
import {hasHotReloaded} from "../Main.js";
import {Me, MeID} from "../Server/DB/users.js";
import {store} from "../Store/index.js";
import {JourneyTab} from "../Store/main/tools/journey.js";
import {NavBar} from "../UI/@Shared/NavBar.js";
import {FeedbackUI} from "./More/Feedback.js";
import {HomePage} from "../UI/Home.js";
import {MorePage} from "../UI/More.js";
import {InAndroid} from "../Utils/Bridge/Bridge_Native.js";
import {OnStoreLoaded_Trigger} from "../Utils/General/GlobalHooks.js";
import {SessionLog} from "./Tools/@Shared/BetweenSessionTypes/SessionLog.js";
import {LogType} from "./Tools/@Shared/LogEntry.js";
import {OnDragEnd, OnDragStart} from "./@Root/RootDragHandler.js";
import {RootStyles} from "./@Root/RootStyles.js";
import {SettingsPanel, SettingsUI} from "./@Shared/NavBar/SettingsPanel.js";
import {NavBar_Android} from "./@Shared/NavBar_Android.js";
import {ContentPage} from "./Content.js";
import {JournalPage} from "./Journal.js";
import {TimelinePage} from "./Timeline.js";
import {ToolsPage} from "./Tools.js";
import {UsersUI} from "./More/Users.js";
import {TermCell_ForDND} from "./Engine/Journey/TermCell.js";
import {ApolloProvider} from "@apollo/client/react";
import {apolloClient} from "../Utils/LibIntegrations/Apollo.js";
import {LinkPreserver} from "./@Root/LinkPreserver.js";
import {LaunchGoogleSignInDialog, SignInPanel_onJWTReceived} from "./@Shared/NavBar/UserPanel.js";
import {EnginePage} from "./Engine.js";
import {StatsPage} from "./Stats.js";
import {UserProfileUI} from "./More/Users/UserProfile.js";
import {MapsPage} from "./Maps.js";
import {ScreenLightOverlay} from "./Engine/Lights/ScreenLightOverlay.js";
import {observer} from "mobx-react";
import {observer_mgl} from "mobx-graphlink";
import {Vec2} from "../Utils/ThreeJS/VectorStructs.js";
import {GetLiveLocalSession_Reactive} from "../Engine/LiveSessionManagement.js";

/*if (InAndroid(0)) {
	require("@codetrix-studio/capacitor-google-auth"); // eslint-disable-line
}*/

ColorPickerBox.Init(ReactColor, chroma);

export const RootUIWrapper = observer_mgl(()=>{
	const [storeReady, setStoreReady] = React.useState(false);
	const mouseSensor = useSensor(MouseSensor);
	const touchSensor = useSensor(TouchSensor);
	const sensors = useSensors(mouseSensor, touchSensor);

	React.useEffect(()=>{
		const init = async()=>{
			const trunk = new AsyncTrunk(store, {
				storage: localStorage,
				delay: 500, // while I would prefer throttling (as implemented in DM project), debouncing is good enough I guess
				// surface errors from the persistence reactions/persist (eg. so we notice if serialization breaks)
				onError: error=>{
					console.error("[StorePersistence] error while persisting state:", error);
				},
			});
			if (startURL.GetQueryVar("clearState") === "true") {
				await trunk.clear();
			}

			// wrap init in try/catch so that a parse/restore error (which mobx-sync currently swallows internally)
			// can't silently kill all persistence without us noticing
			try {
				await trunk.init();
			} catch (ex) {
				console.error("[StorePersistence] error while restoring persisted state:", ex);
				SessionLog(`[StorePersistence] error while restoring persisted state: ${ex}`, LogType.App_Error);
			}
			console.log("Loaded state:", Clone(store));
			OnStoreLoaded_Trigger(store);

			if (!hasHotReloaded) {
				LoadURL(startURL);
			}

			if (PROD && store.main.analyticsEnabled) {
				console.log("Initialized Google Analytics.");
				ReactGA.initialize("UA-21256330-33");
			}

			RunInAction("RootUIWrapper.ComponentWillMount.notifyStoreReady", ()=>setStoreReady(true));
		};
		init();
	}, []);

	if (!storeReady) return null;
	const dndState = store.main.dnd;
	return (
		<DndContext
			sensors={sensors}
			//collisionDetection={rectIntersection}
			//collisionDetection={closestCenter}
			collisionDetection={closestCorners}
			onDragStart={OnDragStart}
			onDragEnd={OnDragEnd}
		>
			<ApolloProvider client={apolloClient}>
				<RootUI/>
			</ApolloProvider>
			<DragOverlay>
				{dndState.activeDraggableInfo?.term != null && <TermCell_ForDND term={dndState.activeDraggableInfo.term}/>}
			</DragOverlay>
		</DndContext>
	);
});

/*(async()=>{
	const {App} = Plugins;

	App.addListener("appStateChange", (state: AppState)=>{
	// state.isActive contains the active state
		console.log("App state changed. Is active?", state.isActive);
	});

	// Listen for serious plugin errors
	/*App.addListener("pluginError", (info: any)=>{
		console.error("There was a serious error with a plugin", err, info);
	});*#/

	var ret = await App.canOpenUrl({url: "com.getcapacitor.myapp"});
	console.log("Can open url: ", ret.value);

	/*ret = await App.openUrl({ url: 'com.getcapacitor.myapp://page?id=ionicframework' });
	console.log('Open url response: ', ret);*#/

	const ret2 = await App.getLaunchUrl();
	if (ret2 && ret2.url) {
		console.log(`App opened with URL: ${ret2.url}`);
	}
	console.log("Launch url: ", ret2);

	App.addListener("appUrlOpen", (data: any)=>{
		console.log(`App opened with URL: ${data.url}`);
	});

	App.addListener("appRestoredResult", (data: any)=>{
		console.log("Restored state:", data);
	});
})();*/

/*window.addEventListener("NotifyLoudnessHit", loudness=> {
});*/

App.addListener("appUrlOpen", data=>{
//Plugins.App.addListener("appUrlOpen", data=>{
	console.log("Got authData (type 2): ", data);
});

const RootUI = observer_mgl((props: {})=>{
	const uiState = store.main;
	const {page} = uiState;

	useEffect(()=>{
		document.addEventListener("mousemove", event=>{
			/*if (event["handledGlobally"]) return;
			event["handledGlobally"] = true;*/

			// useful for various purposes, eg. for unreliable-mouseLeave fix
			g.mousePos = new Vec2(event.pageX, event.pageY);
		});

		if (InAndroid(0)) {
			//require("@codetrix-studio/capacitor-google-auth");
			const gapiWaitTimer = new Timer(1000, ()=>{
				if (g.gapi == null) return;
				gapiWaitTimer.Stop();

				if (MeID() != null) return; // if already signed in, no need to sign-in again (and actually, right now it clears the auth-data if you try to sign-in again!)
				LaunchGoogleSignInDialog(SignInPanel_onJWTReceived);
			}).Start();
		}
	}, []);

	return (
		<Column className="background"/*"unselectable"*/ style={{height: "100%"}}>
			<RootStyles/>
			<ErrorBoundary>
				<AddressBarWrapper/>
				<LinkPreserver/>
				<OverlayUI/>
			</ErrorBoundary>
			{(!InAndroid(1) || uiState.settings.android_showNavBar) &&
			<ErrorBoundary>
				<NavBar/>
			</ErrorBoundary>}
			<ErrorBoundary key={page} /* Add key, so that error message goes away when changing page. */>
				{/*<InfoButton_TooltipWrapper/>*/}
				<main style={{position: "relative", flex: 1, overflow: "hidden", display: "flex", justifyContent: "center", alignItems: "flex-start"}}>
					{page == "more" && <MorePage/>}
					{page == "tools" && <ToolsPage/>}
					{page == "engine" && <EnginePage/>}
					{page == "timeline" && <TimelinePage/>}
					{page == "home" && <HomePage/>}
					{page == "stats" && <StatsPage/>}
					{page == "journal" && <JournalPage/>}
					{page == "content" && <ContentPage/>}
					{page == "maps" && <MapsPage/>}

					{page == "settings" && <SettingsUI asPanel={false}/>}
					{page == "profile" && <UserProfileUI profileUser={Me()!}/>}
				</main>
			</ErrorBoundary>
			{InAndroid(1) && !FullScreenPanelOpen() &&
			<NavBar_Android/>}
		</Column>
	);
});

export function GetNavBarHeights() {
	let result = 0;
	if (!InAndroid(1) || store.main.settings.android_showNavBar) result += 45; // top nav-bar
	if (InAndroid(1) && !FullScreenPanelOpen()) result += 50; // bottom nav-bar
	return result;
}
function FullScreenPanelOpen() {
	// commented; find new way to make full-screen that is less confusing to new users
	//if (store.main.page == "tools" && store.main.tools.subpage == "journey" && store.main.engine.journey.tab == JourneyTab.engine) return true;
	return false;
}

const OverlayUI = observer_mgl(()=>{
	const liveSession = GetLiveLocalSession_Reactive();
	return (
		<div style={{position: "absolute", top: 0, bottom: 0, left: 0, right: 0, overflow: "hidden"}}>
			{liveSession != null && <ScreenLightOverlay/>}
			<MessageBoxLayer/>
			<VMenuLayer/>
			{/* dev-only; placed last so it sits above the page content */}
			<UntrustedCertBanner/>
		</div>
	);
});

// dev convenience for local k8s: the browser must be told once to trust nginx's self-signed cert,
// otherwise every app-server subscription fails. See DetectAndFlagUntrustedWSCert in Apollo.ts.
const UntrustedCertBanner = observer_mgl(()=>{
	const url = store.main.wsCertUntrustedURL;
	if (!store.main.wsCertUntrusted || url == null) return null;

	return (
		<div style={{
			position: "absolute", top: 0, left: 0, right: 0, zIndex: 10000,
			background: "#b45309", color: "white", padding: "6px 10px", fontSize: 13,
			display: "flex", alignItems: "center", gap: 10, fontFamily: "monospace",
		}}>
			<span>
				App-server websocket blocked by an untrusted certificate ({url}). Local clusters have no
				cert-manager, so nginx uses a self-signed cert. Accept it once, then reload.
			</span>
			<a
				href={url}
				target="_blank"
				rel="noreferrer"
				style={{background: "white", color: "#b45309", padding: "3px 8px", borderRadius: 3, fontWeight: "bold", textDecoration: "none", whiteSpace: "nowrap"}}
			>
				Open cert page
			</a>
			<button
				onClick={()=>{
					// the browser only remembers the exception once the tab is (re)loaded, so reload here too
					window.location.reload();
				}}
				style={{background: "transparent", color: "white", border: "1px solid white", borderRadius: 3, padding: "3px 8px", cursor: "pointer"}}
			>
				Reload
			</button>
			<button
				onClick={()=>RunInAction("UntrustedCertBanner.dismiss", ()=>{
					store.main.wsCertUntrusted = false;
					store.main.wsCertUntrustedURL = null;
				})}
				title="Hide until the next websocket failure"
				style={{background: "transparent", color: "white", border: "none", cursor: "pointer", marginLeft: "auto"}}
			>
				✕
			</button>
		</div>
	);
});